export const invoiceSearchForm = {
  header: {
    documents: 'Documents',
    openInvoice: 'Factures en cours',
  },
  label: {
    document: 'Numéro de document',
    purchaseOrder: 'Numéro de B.C.',
    status: 'Afficher',
    filterBy: 'Filtrer par',
    documentType: 'Type de document',
    from: 'Du',
    to: 'Au',
  },
};
export const invoiceResult = {
  header: {
    document: 'Numéro de document',
    documentType: 'Type de document',
    purchaseOrder: 'Numéro de B.C.',
    documentDate: 'Date du document',
    status: 'Statut',
    orignalAmount: 'Montant initial',
    openAmount: 'Montant ouvert',
    attachment: 'Pièce jointe',
    dueDate: 'Date d\'échéance',
    balance: 'Solde',
    docType: 'Type de doc.',
    doc: 'Doc n°',
  },
  widgetHeader: {
    purchaseOrder: 'N° de B.C.',
  },
  sorting: {
    byDate: 'Date du document',
    byDocType: 'Type de document',
    byDocAmount: 'Montant initial',
    byDocStatus: 'Statut',
  },
  nodataMsg: 'Désolé! Aucune facture trouvée',
  showMore: 'Afficher plus',
  sortByMostRecent: 'Date',
  detailedSearch: 'Recherche détaillée',
};
export const knbrAccountSummary = {
  label: {
    accountNumber: 'Numéro de compte',
    accountName: 'Nom',
    address: 'Adresse',
    accountTodaysBalance: "Solde d'aujourd'hui",
    formattedCreditLine: 'Limite de crédit',
    accountStatement: 'Relevé de compte',
    accountDueItems: 'Articles échus',
    accountNotDue: 'Non échu',
    pastDueBalance: 'Solde en souffrance',
  },
};

export const invoice = {
  invoiceSearchForm,
  invoiceResult,
  knbrAccountSummary,
};
